import React from 'react';

const VoiceSkeletonLoader = () => {
  // Create an array of 5 items for female voices and 5 for male voices
  const femaleVoices = Array(4).fill(null);
  const maleVoices = Array(4).fill(null);

  const VoiceCard = () => (
    <div className="flex items-center justify-between p-2 mb-2 bg-background-main rounded-lg animate-pulse">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
        <div className="h-4 w-24 bg-gray-200 rounded"></div>
      </div>
      <div className="w-12 h-12 bg-gray-200 rounded-lg"></div>
    </div>
  );

  return (
    <div className="bg-background flex flex-col rounded-md p-3 px-4 w-full lg:w-[340px]">
      <div className="text-text-primary uppercase text-sm mb-4">
        Assign Voice
      </div>

      <div className=" hidden lg:block mb-4">
        <div className="text-text-secondary mb-2">Female</div>
        {femaleVoices.map((_, index) => (
          <VoiceCard key={`female-${index}`} />
        ))}
      </div>

      <div className="hidden lg:block mb-4">
        <div className="text-gray-400 mb-2">Male</div>
        {maleVoices.map((_, index) => (
          <VoiceCard key={`male-${index}`} />
        ))}
      </div>

      <div className="mt-auto w-full">
        <div className="w-full h-10 bg-gray-200 rounded-lg animate-pulse"></div>
      </div>
    </div>
  );
};

export default VoiceSkeletonLoader;
